/**
 * EL PIN DESDE LA FICHA UNICA (SUJ-T13 puntos 1 y 3; A #32732 dejo la parte panel a P).
 *
 * El PIN de colaboradores.pin_hash es UNO por ficha de operacion y lo validan el kiosko, el login del Desktop 1.5 y la
 * puerta del equipo del Arcade (Ares, SUJ-T13). La ficha unica lo deja cambiar por negocio con la misma ruta que ya usa
 * Colaboradores: PATCH .../colaboradores/{id}/pin, que la API cierra con [RequireManager] (manager o admin).
 * POST .../pin/cambiar es la puerta del Desktop (pide probar un PIN) y no se usa desde el panel.
 *
 * Sin DOM: lo prueba scripts/check-pin-de-la-ficha.mjs.
 */

const texto = (v) => (v == null ? '' : String(v));

/** Quien ve -Cambiar PIN-: los roles que acepta [RequireManager]. A los demas la API les responderia 403. */
export function puedeCambiarPin(rol) {
  return ['admin', 'manager'].includes(texto(rol).toLowerCase());
}

/** Para que sirve el PIN y que NO cambia (SUJ-T13 punto 3). */
export const PARA_QUE_SIRVE_EL_PIN =
  'Este PIN sirve para el Desktop 1.5, el kiosko de asistencia y la puerta del equipo en el Arcade. '
  + 'La clave del panel y la del Desktop 1.0 son otras llaves: cambiar el PIN no las toca.';

/** La regla de la API (AsistenciaService.SetPinAsync, CambioDePinController.PinBienFormado): de 4 a 6 digitos. */
export function validarPinNuevo(pin, confirmacion) {
  const p = texto(pin).trim();
  if (!/^\d{4,6}$/.test(p)) return { ok: false, error: 'El PIN debe tener entre 4 y 6 digitos numericos' };
  if (p !== texto(confirmacion).trim()) return { ok: false, error: 'Los PINs no coinciden' };
  return { ok: true, pin: p };
}

/** La linea de cada negocio en la ficha: si tiene PIN (nunca el PIN) y que boton lleva. */
export function lineaDePin(ficha, rol) {
  const tiene = ficha?.tienePin === true;
  const puede = puedeCambiarPin(rol);
  return {
    estado: tiene ? 'Tiene PIN' : 'Sin PIN',
    tiene,
    boton: puede ? (tiene ? 'Cambiar PIN' : 'Poner PIN') : null
  };
}
